<template>
  <v-menu
    ref="menu1"
    v-model="menu1"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
    :disabled="disabled"
  >
    <template slot='activator'>
      <v-text-field
        prepend-icon='event'
        return-masked-value
        mask="date"
        :value="dateFormatted"
        :label="label"
        @change="dateFormatted = $event"
        :rules="validationRules"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-date-picker v-model="dateIso"  @input="menu1 = false" :max="max"></v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'
export default {
  model: {
    prop: 'date',
    event: 'change',
  },
  props: {
    date: String,
    label: String,
    previousDatesOnly: false,
    disabled: Boolean,
    rules: Array,
    max: String,
  },
  data() {
    return {
      menu1: false,
    }
  },
  computed: {
    dateFormatted: {
      get() {
        if (this.date) {
          let date = moment(this.date).format('MM/DD/YYYY')
          return date
        } else {
          return null
        }
      },
      set(newValue) {
        this.$emit('change', new Date(newValue).toISOString().substr(0, 10))
      },
    },
    dateIso: {
      get() {
        if (this.date) {
          let date = new Date(this.date).toISOString().substr(0, 10)
          return date
        } else {
          return null
        }
      },
      set(newValue) {
        this.$emit('change', newValue)
      },
    },
    validationRules() {
      let rules = this.rules || []
      rules.push(
        (val) => !val || moment(val).isValid() || 'Please enter a valid date'
      )
      return rules
    },
  },
}
</script>

<style>
</style>